import { Col, Row } from "react-bootstrap";
import DropdownSelect from "../components/formFields/dropdownSelect/DropdownSelect";
import LargeFloatingTextField from "../components/formFields/largeFloatingText/LargeFloatingTextField";
import IDepartment from "../models/macrowayFeedback/IDepartment";
import IMacroWayFeedback from "../models/macrowayFeedback/IMacroWayFeedback";
import { IFeedbackValidation } from "./Validation";
import { useTranslation } from "react-i18next";
import IDropzoneItem from "../models/dropzone/IDropzoneItem";
import Dropzone from "../components/formFields/dropzone/Dropzone";
import { v4 as uuid } from "uuid";

interface IFeedbackFormProps {
    departments: IDepartment[];
    feedback: IMacroWayFeedback;
    validation: IFeedbackValidation;
    isReadOnly: boolean;
    dropzoneFiles: IDropzoneItem[];
    setDropzoneFiles: (files: IDropzoneItem[]) => void;
    onInputChange: (key: keyof IMacroWayFeedback, value: string) => void;
}

export const FeedbackForm = (props: IFeedbackFormProps) => {
    const { t } = useTranslation();
    
    const handleFileDrop = (acceptedFiles: File[]) => {
        const newFiles = acceptedFiles.map(file => ({ id: uuid(), file }));
        props.setDropzoneFiles([...props.dropzoneFiles, ...newFiles]);
    };

    const handleFileRemove = (id: string) => props.setDropzoneFiles(props.dropzoneFiles.filter(f => f.id !== id));

    const departmentId = props.feedback?.departmentId || props.departments[0].name;

    const departmentName = !!props.feedback.departmentId
        ? props.departments.find(t => t.id === props.feedback.departmentId)?.name
        : props.departments[0].name;
    
    return (
        <Row>
            <Col>
                <DropdownSelect 
                    title={t("macroway-feedback.form.fields.department.label")}
                    items={props.departments}
                    value={(departmentId || "").toString()}
                    itemValueField="id"
                    itemLabelField="name"
                    valueLabel={departmentName!}
                    validation={props.validation?.department!}
                    validationMessage={t("macroway-feedback.form.fields.department.validation")}
                    disabled={props.isReadOnly}
                    onchange={(item: any) => props.onInputChange("departmentId", item.id)} />

                <LargeFloatingTextField
                    label={t("macroway-feedback.form.fields.description.label")}
                    placeholder={t("macroway-feedback.form.fields.description.label")}
                    disabled={props.isReadOnly}
                    onChange={(value) => props.onInputChange("description", value)}
                    validation={props.validation?.description!}
                    type="textarea"
                    value={props.feedback?.description!}
                    height={150}
                    />

                <Row>
                    <Col>
                        <Dropzone
                            items={props.dropzoneFiles}
                            disabled={props.isReadOnly}
                            onDrop={handleFileDrop}
                            onRemove={handleFileRemove}
                            />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}